import { RPCRefresh } from '@/client/rpc'

export default async function unsubscribeWebPush(subscription: PushSubscription): Promise<void> {
  await RPCRefresh.deleteWebPushSubscription({
    subscription: JSON.stringify(subscription),
  })

  await subscription.unsubscribe()
}
